export * from './response-to-state';
export * from './affiliation';
export * from './shared';
export * from './virtual-transform-data';
export * from './virtual-affiliation';
export * from './generate-commerce-code';
export * from './new-generate-commerce-code';
export * from './new-generate-commerce-code-multi-adrress';
export * from './requestCodes';


//////////////////
// WEBPACK FOOTER
// ./src/mappers/index.js
// module id = ./src/mappers/index.js
// module chunks = 34